import { RestrictedAccountObjectApiFacade } from "../restricted-account-object/restricted-account-object.api-facade";
import { Group } from "./group.model";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class GroupApiFacade extends RestrictedAccountObjectApiFacade<Group> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Group> {
        return this.GET(`/accounts/${accountId}/groups/${id}`, options)
            .map(object => new Group({
                account: accountId,
                ...object
            }));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<Group>> {
        return this.CGET(`/accounts/${accountId}/groups`, options)
            .map(objects => objects.map(object => new Group({
                account: accountId,
                ...object
            })));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/group/group.api-facade.ts